module.exports = __webpack_public_path__ + "static/media/tenant_id.5bae53c2.jpg";